import Benefits from "../components/Home2/Benefits";
import About from "../components/Home2/About";
import About2 from "../components/Home2/About2";
import Blogs from "../components/Home2/Blogs";
import Collaborations from "../components/Home2/Collaborations";
import Courses from "../components/Home2/Courses";
import HeroSection from "../components/Home2/HeroSection";
import Instructors from "../components/Home2/Instructors";
import OurPartners from "../components/Home2/OurPartners";
import Testimonials from "../components/Home2/Testimonials";
import AnimatedSection from "../components/Shared/AnimatedSection";
import BooksSection from "../components/Home/BooksSection";
const Home2 = () => {
  console.log("home 2");

  return (
    <>
      <HeroSection />
      <AnimatedSection>
        <Collaborations />
      </AnimatedSection>
      <AnimatedSection>
        <About />
      </AnimatedSection>
      <AnimatedSection>
        <Courses />
      </AnimatedSection>
      <AnimatedSection>
        <About2 />
      </AnimatedSection>
      <AnimatedSection>
        <Instructors />
      </AnimatedSection>
      <AnimatedSection>
        <BooksSection />
      </AnimatedSection>
      <AnimatedSection>
        <OurPartners />
      </AnimatedSection>
      <AnimatedSection>
        <Benefits />
      </AnimatedSection>
      <AnimatedSection>
        <Testimonials />
      </AnimatedSection>
      <div className="sm:pb-24 pb-16" />
      <AnimatedSection>
        <Blogs />
      </AnimatedSection>
    </>
  );
};

export default Home2;
